var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',{staticClass:"shadowed"},[_c('CrewForm',{on:{"submit":_vm.add,"remove_city":_vm.removeCity,"add_city":_vm.addCity},model:{value:(_vm.create),callback:function ($$v) {_vm.create=$$v},expression:"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }